export default function () {
  const grid = document.querySelector('[data-quotes-grid]')
  const prevButton = document.querySelector('[data-quotes-prev]')
  const nextButton = document.querySelector('[data-quotes-next]')

  if (!grid || !prevButton || !nextButton) {
    console.warn('Quote carousel elements not found')
    return
  }

  const cardWidth = 350 // 350px base width from CSS
  const gap = 32 // 32px gap from CSS
  const scrollAmount = cardWidth + gap

  prevButton.addEventListener('click', function () {
    grid.scrollBy({ left: -scrollAmount, behavior: 'smooth' })
  })

  nextButton.addEventListener('click', function () {
    grid.scrollBy({ left: scrollAmount, behavior: 'smooth' })
  })
}
